/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable camelcase */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import ReactToolTip from '@tcp/core/src/components/common/atoms/ReactToolTip';
import { parseStoreOpeningAndClosingTimesSFCC } from '@tcp/core/src/utils/parseStoreHours.js';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import CartItemTileLabels, {
  GLOBAL_CART_ITEM_TILE_LABELS,
} from '@tcp/core/src/utils/labels/globalCartItemTile.labels';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
} from '@tcp/core/src/utils/labels/globalAccessibility.labels';
import parseStoreAddress from '@tcp/core/src/utils/parseStoreAddress.js';
import { capitalizeWords, getDateInformation, getIconPath } from '@tcp/core/src/utils/utils';
import { getAPIConfig, getTranslateDateInformation } from '@tcp/core/src/utils/index.js';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles from '../styles/Pickup.style';
import Anchor from '../../../../../../common/atoms/Anchor';
import CARTPAGE_CONSTANTS from '../../../../CartItemTile/CartItemTile.constants';
import { getNextOpenDay } from '../../../../../../../utils/getNextDayDate.util';
import { getStoreInformation } from '../../../../CartItemTile/organisms/ProductTileWrapper/views/ProductTileGroup.view';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblPickup,
  lblItemsBy,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const PickupLocationLabels = {
  account: {
    orders: {
      lbl_orders_pickupitemstore: 'Pickup Store, ',
    },
  },
  Browse: {
    ProductPickup: {
      lbl_Product_pickup_CHANGE_STORE_DM: 'Change Store',
    },
  },
};

const getAddressHeader = (label, openingTime, closingTime) => {
  return (
    <BodyCopy fontFamily="secondary" fontSize="fs12">
      {`${label}: ${openingTime} - ${closingTime}`}
    </BodyCopy>
  );
};

const getItemInfoDetails = (tile) => {
  const { productInfo, itemInfo, miscInfo } = tile;
  return {
    c_prodPartNo: productInfo.productPartNumber,
    c_brand: itemInfo.itemBrand,
    c_TCPColor: itemInfo.color,
    c_TCPStyleType: productInfo.tcpStyleType,
    c_TCPProductIndStore: miscInfo.TCPProductIndStore,
    c_TCPimages: itemInfo.imagePath,
    c_fit: itemInfo.fit || null,
    c_size: itemInfo.size,
    c_variant: productInfo.variant,
    productId: productInfo.generalProductId,
    itemId: itemInfo.itemId,
    quantity: itemInfo.qty.toString(),
    c_TCPStyleQTY: productInfo.tcpStyleQty,
    c_TCPWebOnlyFlagStore: miscInfo.isOnlineOnly,
    shipment_id: miscInfo.shipmentId,
    c_list_price: itemInfo.wasPrice,
    c_multiPack: productInfo.multiPack || false,
  };
};

const isEnterKey = (e) => {
  return e.keyCode === 13;
};
const getOrderTypeValue = (orderType) => {
  const { ECOM, BOPIS, BOSS, HOME, PURE_BOSS, PURE_BOPIS, PURE_ECOM } = CARTPAGE_CONSTANTS;
  let value;
  if (orderType === ECOM || orderType === PURE_ECOM) {
    value = HOME;
  } else if (orderType === BOPIS || orderType === PURE_BOPIS) {
    value = BOPIS?.toLowerCase();
  } else if (orderType === BOSS || orderType === PURE_BOSS) {
    value = BOSS?.toLowerCase();
  }
  return value;
};

const changeStore = (e, onPickUpOpenClick, props) => {
  if (e) {
    e.preventDefault();
  }
  const { productItems, orderType, userDefaultStore } = props;
  const firstItemInfo = getItemInfoDetails(productItems[0]);

  onPickUpOpenClick({
    fromBagPage: true,
    fromChangeStore: true,
    currentProduct: {
      ...firstItemInfo,
      c_orderItemType: getOrderTypeValue(orderType),
      toggle: getOrderTypeValue(orderType),
    },
    isProductPickup: true,
    isBopisPickup: getOrderTypeValue(orderType) === 'bopis',
    pickupSelectedStore: userDefaultStore,
  });
};

const OrderTooltip = (deliveryItem) => {
  const cartItemTileLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_CART_ITEM_TILE_LABELS,
    CartItemTileLabels
  );
  const openingClosingTimes = parseStoreOpeningAndClosingTimesSFCC(deliveryItem?.c_storeHours);
  const parsedAddress = parseStoreAddress(deliveryItem);
  const { address1, address2, city, stateCode, postalCode, c_storeName, storePhoneNo } =
    parsedAddress;
  return (
    <>
      <BodyCopy
        component="div"
        fontWeight="extrabold"
        fontSize="fs12"
        className="store-name"
        fontFamily="secondary"
      >
        {c_storeName}
      </BodyCopy>
      {deliveryItem && (
        <>
          <BodyCopy component="div" fontWeight="regular" fontSize="fs12" fontFamily="secondary">
            {`${address1}`}
          </BodyCopy>
          {address2 && (
            <BodyCopy component="div" fontWeight="regular" fontSize="fs12" fontFamily="secondary">
              {address2}
            </BodyCopy>
          )}
          <BodyCopy component="div" fontWeight="regular" fontSize="fs12" fontFamily="secondary">
            {`${city}, ${stateCode}, ${postalCode}`}
          </BodyCopy>
          {getAddressHeader(
            renderLabel(cartItemTileLabels.lbl_cartTile_today, 'lbl_cartTile_today'),
            openingClosingTimes.todayOpeningTime,
            openingClosingTimes.todayClosingTime
          )}
          {getAddressHeader(
            renderLabel(cartItemTileLabels.lbl_cartTile_tomorrow, 'lbl_cartTile_tomorrow'),
            openingClosingTimes.tomorrowOpeningTime,
            openingClosingTimes.tomorrowClosingTime
          )}
          <BodyCopy fontFamily="secondary" fontSize="fs12">
            {`${renderLabel(cartItemTileLabels.lbl_cartTile_phone, 'lbl_cartTile_phone')}: ${
              storePhoneNo || ''
            }`}
          </BodyCopy>
        </>
      )}
    </>
  );
};

const renderTooltip = (bossSwitchEnabled, shipment, toolTipMinWidth) => {
  const globalAccessibilityLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ACCESSIBILITY_LABELS,
    GlobalAccessibilityLabels
  );
  return (
    <div className="toolTip-wrapper">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="fav-icon"
      >
        <path
          d="M13.8855 6.22448C14.1098 5.99523 13.986 5.59594 13.676 5.54869L9.49364 4.9114C9.37072 4.89273 9.26432 4.81165 9.20944 4.69469L7.33874 0.720719C7.20014 0.426427 6.79974 0.426427 6.66114 0.720719L4.791 4.69469C4.73556 4.81165 4.62916 4.89273 4.50624 4.9114L0.323847 5.54869C0.0138847 5.59594 -0.109596 5.99523 0.114405 6.22448L3.14095 9.31762C3.22971 9.40862 3.27059 9.53987 3.24959 9.6682L2.53502 14.0359C2.4821 14.3597 2.80635 14.6064 3.08355 14.4536L6.8241 12.3915C6.93442 12.3308 7.06602 12.3308 7.17578 12.3915L10.9166 14.4536C11.1938 14.6064 11.5178 14.3597 11.4649 14.0359L10.7506 9.6682C10.7296 9.53987 10.7702 9.40862 10.8589 9.31762L13.8855 6.22448Z"
          fill="black"
        />
      </svg>
      <div className="confirmation-fullfillment-details">
        <ReactToolTip
          fontFamily="secondary"
          message={OrderTooltip(shipment?.shippingAddress)}
          aligned="right"
          className="toolTip"
          minWidth={toolTipMinWidth}
          direction="custom-right"
        >
          <Image
            height="14"
            width="14"
            src={getIconPath('info-icon')}
            alt={renderLabel(globalAccessibilityLabels.lbl_info_icon, 'lbl_info_icon')}
          />
        </ReactToolTip>
      </div>
    </div>
  );
};

const getBopisCutOffTime = ({
  isDisplayPickupTimeEnabled,
  storeHoursThreshold,
  pickUpToday,
  storeInformation,
}) => {
  if (isDisplayPickupTimeEnabled) {
    const dayDetails = getNextOpenDay({
      hoursBeforeClose: storeHoursThreshold,
      storeInformation,
    });
    const { dayName, openDate, openDateForSPC } = dayDetails || {};
    if (openDate) {
      return `${dayName}${openDate ? `, ${openDate}` : ''}`;
    }
    if (openDateForSPC) {
      return `${dayName}${openDateForSPC ? `, ${openDateForSPC}` : ''}`;
    }

    return dayName ? `${dayName}` : '';
  }
  return pickUpToday;
};

const getBopisDuration = ({
  bopisDate,
  shipment,
  isDisplayPickupTimeEnabled,
  storeHoursThreshold,
}) => {
  const storeInformation = getStoreInformation(shipment);
  return getBopisCutOffTime({
    pickUpToday: bopisDate,
    isDisplayPickupTimeEnabled,
    storeHoursThreshold,
    storeInformation,
  });
};

function PickupLocation({ className, shipments, ...props }) {
  const {
    onPickUpOpenClick,
    isPickupOrder,
    bossLabels,
    orderType,
    updateStoreItem,
    storeUpdateCompletedState,
    userDefaultStore,
    productItems,
    bossSwitchEnabled,
    isNewEddViewCheckout,
    isDisplayPickupTimeEnabled,
    storeHoursThreshold,
  } = props;
  const ordersLabel = getLabelFromCopyOrFromTranslation('account.orders', PickupLocationLabels);
  const productPickupLabel = getLabelFromCopyOrFromTranslation(
    'Browse.ProductPickup',
    PickupLocationLabels
  );
  const toolTipMinWidth = '205px';
  const apiConfig = getAPIConfig();
  const today = getTranslateDateInformation('', apiConfig.language);
  const bossStartDate = (shipment) => getDateInformation(shipment?.bossMinDate);
  const bossEndDate = (shipment) => getDateInformation(shipment?.bossMaxDate);
  const bopisDate = `Today ${today.month} ${today.date}`;
  return (
    <div className={className}>
      {shipments?.length > 0
        ? shipments.map((shipment) => {
            if (shipment?.shipmentId !== 'me' && shipment?.itemsCount > 0) {
              return (
                <div className="pickup-location-card">
                  {(bossSwitchEnabled || isNewEddViewCheckout) && (
                    <div className="new-location-style">
                      <BodyCopy
                        component="div"
                        fontFamily="secondary"
                        fontWeight="bold"
                        fontSize="fs18"
                        className="elem-mb-XXS spc-card-content-fields"
                      >
                        {renderLabel(
                          ordersLabel.lbl_orders_pickupitemstore,
                          'lbl_orders_pickupitemstore'
                        )?.replace(',', '')}
                      </BodyCopy>
                      {bossSwitchEnabled && (
                        <Anchor
                          fontSizeVariation="medium"
                          className="change-store-link"
                          role="button"
                          tabIndex="0"
                          underline
                          noLink
                          handleLinkClick={(e) =>
                            changeStore(e, onPickUpOpenClick, {
                              isPickupOrder,
                              bossLabels,
                              orderType,
                              updateStoreItem,
                              storeUpdateCompletedState,
                              userDefaultStore,
                              productItems,
                            })
                          }
                          onKeyDown={(e) => {
                            if (isEnterKey(e)) {
                              changeStore(e, onPickUpOpenClick, {});
                            }
                          }}
                        >
                          {renderLabel(
                            productPickupLabel.lbl_Product_pickup_CHANGE_STORE_DM,
                            'lbl_Product_pickup_CHANGE_STORE_DM'
                          )}
                        </Anchor>
                      )}
                    </div>
                  )}
                  <div className="pickup-location-wrapper">
                    <div className="pickup-location-container">
                      <span className="pickup-location-name">
                        {shipment?.shippingAddress?.c_storeName?.toLowerCase()}
                      </span>
                      {renderTooltip(bossSwitchEnabled, shipment, toolTipMinWidth)}
                    </div>
                  </div>

                  <div>
                    <div className="pickup-location-container">
                      <span className="pickup-location-address">
                        {capitalizeWords(shipment?.shippingAddress?.address1)}
                      </span>
                    </div>
                    <div>
                      <span className="pickup-location-city-state">
                        {`${capitalizeWords(
                          shipment?.shippingAddress?.city
                        )}, ${shipment?.shippingAddress?.stateCode?.toUpperCase()}`}
                      </span>
                    </div>
                  </div>
                  <div className="pickup-location-container">
                    <span className="pickup-location-count">
                      {`${getLabelFromCopyOrFromTranslation(
                        `${GLOBAL_GENERIC_LABELS}.${lblPickup}`,
                        GlobalGenericLabels
                      )} ${shipment.itemsCount} ${getLabelFromCopyOrFromTranslation(
                        `${GLOBAL_GENERIC_LABELS}.${lblItemsBy}`,
                        GlobalGenericLabels
                      )}`}
                    </span>
                    <span className="pickup-location-date">
                      {shipment?.shippingMethod.id === 'BOPIS'
                        ? getBopisDuration({
                            bopisDate,
                            shipment,
                            isDisplayPickupTimeEnabled,
                            storeHoursThreshold,
                          })
                        : `${bossStartDate(shipment).day}. ${bossStartDate(shipment).month} ${
                            bossStartDate(shipment).date
                          } - ${bossEndDate(shipment).day}. ${bossEndDate(shipment).month} ${
                            bossEndDate(shipment).date
                          }`}
                    </span>
                  </div>
                </div>
              );
            }
            return null;
          })
        : null}
    </div>
  );
}

PickupLocation.propTypes = {
  className: PropTypes.string.isRequired,
  shipments: PropTypes.shape({
    map: PropTypes.func,
    length: PropTypes.func,
    shippingAddress: PropTypes.shape({
      c_storeName: PropTypes.string,
    }),
  }).isRequired,
};

PickupLocation.defaultProps = {};

export default withStyles(PickupLocation, styles);
